import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-search-slice" }

import {inject} from 'vue';
    import {MICRO_FRONTEND} from '@/unlogged/keys';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import {HeaderSearchSliceSlice} from '@/unlogged/prismicio';
    import {FreelanceSearch} from '@malt/vue-prismic';
    import {getPageLocale} from '@malt/dom';
    import {useWindowNavGlobals} from '@/unlogged/composables/useWindowNavGlobals';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: getSliceComponentProps<HeaderSearchSliceSlice>(),
  setup(__props) {

    

    const isMicroFrontend = inject(MICRO_FRONTEND);

    const locale = getPageLocale() ?? 'fr-FR';

    const {searchFormVisible} = useWindowNavGlobals(isMicroFrontend || false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_unref(searchFormVisible))
      ? (_openBlock(), _createBlock(_unref(PrismicRichText), {
          key: 0,
          field: _ctx.slice.primary.title
        }, null, 8, ["field"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(FreelanceSearch), {
      id: "headerSearchV2",
      "category-label": _ctx.slice.primary.categoryLabel,
      "location-label": _ctx.slice.primary.locationLabel,
      "search-link-text": _ctx.slice.primary.searchLinkText,
      "search-link": _ctx.slice.primary.searchLink,
      "submit-project-link-text": _ctx.slice.primary.submitProjectLinkText,
      "submit-project-link": _ctx.slice.primary.submitProjectLink,
      "between-ctas-text": _ctx.slice.primary.betweenCTAsText,
      "missing-category-error-text": _ctx.slice.primary.missingCategoryErrorText,
      "remote-in-country-label": _ctx.slice.primary.remoteInCountryLabel,
      "remote-in-europe-label": _ctx.slice.primary.remoteInEuropeLabel,
      "heap-prefix": "navbar-unlogged-search-expand",
      locale: _unref(locale),
      "search-page": _unref(searchFormVisible)
    }, null, 8, ["category-label", "location-label", "search-link-text", "search-link", "submit-project-link-text", "submit-project-link", "between-ctas-text", "missing-category-error-text", "remote-in-country-label", "remote-in-europe-label", "locale", "search-page"])
  ]))
}
}

})